import { cloneDeep } from 'lodash-es';

import { SET_NAVIGATOR_ENTITIES, SET_NAVIGATOR_ORGS } from './mutation-types';

export default {
  [SET_NAVIGATOR_ENTITIES](state, data) {
    const { composites, consumers, dags, dataProducts, datasets, dispatches, pipelines, suppliers } = data;

    state.composites = cloneDeep(composites);
    state.consumers = cloneDeep(consumers);
    state.dags = cloneDeep(dags);
    state.dataProducts = cloneDeep(dataProducts);
    state.datasets = cloneDeep(datasets);
    state.dispatches = cloneDeep(dispatches);
    state.pipelines = cloneDeep(pipelines);
    state.suppliers = cloneDeep(suppliers);
  },

  [SET_NAVIGATOR_ORGS](state, data) {
    state.orgs = cloneDeep(data);
  },
};
